import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import { Modal, Button, Form } from "react-bootstrap";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";
import { SubjectCategoryMasterEndpoint } from "../../../Utility/Endpoints";

const SubjectCategoryMaster = () => {
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentCategory, setCurrentCategory] = useState({
    subjectCategoryID: 0,
    subjectCategoryName: "",
  });
  const [isEdit, setIsEdit] = useState(false);

  const apiUrl = SubjectCategoryMasterEndpoint;

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(apiUrl);
      setCategories(response.data);
    } catch (error) {
      toast.error("Failed to fetch categories");
    }
  };

  const handleShowModal = (category = { subjectCategoryID: 0, subjectCategoryName: "" }) => {
    setCurrentCategory(category);
    setIsEdit(category.subjectCategoryID !== 0);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentCategory({ subjectCategoryID: 0, subjectCategoryName: "" });
  };

  const handleChange = (e) => {
    setCurrentCategory({
      ...currentCategory,
      subjectCategoryName: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      if (isEdit) {
        await axios.put(`${apiUrl}/${currentCategory.subjectCategoryID}`, currentCategory);
        toast.success("Category updated successfully");
      } else {
        await axios.post(apiUrl, currentCategory);
        toast.success("Category added successfully");
      }
      fetchCategories();
      handleCloseModal();
    } catch (error) {
      toast.error("Failed to save category");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await axios.delete(`${apiUrl}/${id}`);
        toast.success("Category deleted successfully");
        fetchCategories();
      } catch (error) {
        toast.error("Failed to delete category");
      }
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>Manage Subject Categories</h3>
          <Button variant="primary" onClick={() => handleShowModal()}>
            Add Subject Category
          </Button>
        </div>
        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Category Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((category, index) => (
              <tr key={category.subjectCategoryID}>
                <td>{index + 1}</td>
                <td>{category.subjectCategoryName}</td>
                <td>
                  <Button
                    variant="warning"
                    onClick={() => handleShowModal(category)}
                    className="me-2"
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => handleDelete(category.subjectCategoryID)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit Subject Category" : "Add Subject Category"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Subject Category Name</Form.Label>
              <Form.Control
                type="text"
                value={currentCategory.subjectCategoryName}
                onChange={handleChange}
                placeholder="Enter category name"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>
            {isEdit ? "Update" : "Add"}
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default SubjectCategoryMaster;
